import { shortcutLabel } from './shortcutLabel';

/**
 * True for Cmd+Enter on a Mac, or Ctrl+Enter elsewhere: the key that presses a form's main button
 * from anywhere in it. An Enter that ends an input method's composition is left alone. So is a held
 * key's repeat, so holding the key on one dialog cannot press the button on the dialog after it.
 */
export function isSubmitShortcut(event: KeyboardEvent): boolean {
    return event.key === 'Enter' && (event.metaKey || event.ctrlKey) && !event.isComposing && !event.repeat;
}

/** "⌘↵" on a Mac and "Ctrl+↵" elsewhere, for the button the shortcut presses. */
export const submitShortcutLabel = (): string => shortcutLabel('↵');
